<template>
  <div id="fcs">
    <div class="content-header">
      <h3>{{ item.Key }}</h3>
    </div>
    <div class="album-info">
      <div class="album-main-info">
        <!-- poster -->
        <div class="album-image-galery">
          <swiper :options="options" ref="mySwiper">
            <!-- (!)  IMPORTANT V-FOR USING (!) -->
            <swiper-slide>
              <img :src="file(item.CoverLink)" />
            </swiper-slide>
            <template v-if="album_images">
              <swiper-slide
                v-for="(slide, index) in album_images(item.CoverLink)"
                :key="index"
              >
                <img :src="file(slide.link)" />
              </swiper-slide>
            </template>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="slide-controls-area">
            <div class="arrows">
              <i
                class="slide-nav prev diginity dg-left-arrow-thin"
                id="slide-nav__prev"
              ></i>
              <i
                class="slide-nav next diginity dg-right-arrow-thin"
                id="slide-nav__next"
              ></i>
            </div>
            <div class="swipe-paginate-area">
              <div id="swiper-pagination" class="swp-paginate"></div>
            </div>
          </div>
        </div>
        <!--  album info -->
        <div class="album-product-info">
          <ul>
            <li>
              <strong>{{ t.allWorks.albums.albumItem.name }}</strong> :
              <span>{{ item.Key }}</span>
            </li>
            <li>
              <strong>{{ t.allWorks.albums.albumItem.producer }}</strong> :
              <span>{{ item.Producer }}</span>
            </li>
            <li>
              <strong>{{ t.allWorks.albums.albumItem.year }}</strong> :
              <span>{{ new Date(item.Date).getFullYear() }}</span>
            </li>
          </ul>
          <div class="description">
            <div v-html="item.Description"></div>
          </div>
        </div>
      </div>
      <!-- Access link -->
      <div
        class="access-list"
        v-if="
          item.TTNetLink ||
            item.TurkcellLink ||
            item.SpotifyLink ||
            item.DeezerLink ||
            item.DRLink ||
            item.YoutubeLink
        "
      >
        <p>{{ t.allWorks.albums.albumItem.access }} :</p>
        <ul>
          <li v-if="item.DRLink">
            <a :href="item.DRLink" target="_blank" class="diginity dg-dnr"></a>
            <span>D n R</span>
          </li>
          <li v-if="item.DeezerLink">
            <a
              :href="item.DeezerLink"
              target="_blank"
              class="diginity dg-dezeer"
            ></a>
            <span>deezer</span>
          </li>
          <li v-if="item.ITunesLink">
            <a
              :href="item.ITunesLink"
              target="_blank"
              class="diginity dg-itunes"
            ></a>
            <span>iTunes</span>
          </li>
          <!-- <li v-if="item.TurkcellLink">
            <a
              :href="item.TurkcellLink"
              target="_blank"
              class="diginity dg-fizy"
            ></a>
            <span>fizy</span>
          </li> -->
          <li v-if="item.SpotifyLink">
            <a
              :href="item.SpotifyLink"
              target="_blank"
              class="diginity dg-spotify"
            ></a>
            <span>Spotify</span>
          </li>
          <li v-if="item.YoutubeLink">
            <a
              :href="item.YoutubeLink"
              target="_blank"
              class="diginity dg-youtube"
            ></a>
            <span>Youtube</span>
          </li>
          <!--  <li v-if="item.TTNetLink">
            <a
              :href="item.TTNetLink"
              target="_blank"
              class="diginity dg-muud"
            ></a>
            <span>Muud</span>
          </li> -->
        </ul>
      </div>
      <!--  TRACK/LYRIC -->
      <div class="track-and-lyric-content" v-if="Array.isArray(tracklist)">
        <!-- track list -->
        <div class="track-list">
          <table class="tracklist-table">
            <thead>
              <tr>
                <th>{{ t.allWorks.albums.albumItem.song }}</th>
                <th>{{ t.allWorks.albums.albumItem.listen }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(track, i) in tracklist"
                :key="i"
                :class="{ active: currentClass == track.ID }"
              >
                <td>
                  <span
                    class="track-title"
                    @click="(lyric = track), (currentClass = track.ID)"
                  >
                    {{ routerCheck() ? "&sdot;" : `${track.Position}.` }}
                    {{ track.Key }}
                  </span>
                </td>
                <td>
                  <span
                    class="diginity"
                    @click="
                      change(file(track.FileLink), track.Position),
                        (lyric = track),
                        (currentClass = track.ID)
                    "
                    :class="{
                      'track-demo': true,
                      'dg-play-border': track.Position !== current,
                      'dg-stop-border': track.Position == current,
                      pulse: track.Position == current,
                    }"
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- demoplayer -->
          <aplayer
            ref="demoPlayer"
            style="display: none"
            v-if="musicSource.src"
            :music="musicSource"
            @ended="onMusicEnded"
            @pause="toggle"
            controls
            mini
          />
        </div>
        <!-- lyric view -->
        <div class="lyric-view" v-if="lyric">
          <div class="lyric-info">
            <div class="info-list lyric-info-list">
              <ul>
                <li>
                  <strong>{{ t.allWorks.albums.albumItem.lyrics }}</strong> :
                  <span>{{ replaced("Lyricist:", lyric) }}</span>
                </li>
                <li>
                  <strong>{{ t.allWorks.albums.albumItem.by }}</strong> :
                  <span>{{ replaced("Composer:", lyric) }}</span>
                </li>
                <li>
                  <strong>{{ t.allWorks.albums.albumItem.arranged }}</strong> :
                  <span>{{ replaced("Editor:", lyric) }}</span>
                </li>
              </ul>
            </div>
            <div v-if="lyric.NotesFileLink" class="song-note">
              <a
                :href="
                  'https://docs.google.com/gview?url=' +
                    file(lyric.NotesFileLink, true)
                "
                target="_BLANK"
                class="diginity dg-note"
              >
                <small>{{ t.note }}</small>
              </a>
            </div>
          </div>
          <!-- lyric view-->
          <h3 class="lyric-title">{{ lyric.Key }}</h3>
          <div class="lyric-content" v-html="lyric.Lyrics"></div>
        </div>
      </div>
      <template v-else>
        <div
          class="spinner"
          v-if="Array.isArray(tracklist) && !tracklist.length"
        >
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <p class="response-error" v-if="tracklist == undefined">
          <span>{{
            lng == "tr" ? "Kayıt bulunamadı" : "No Records Found"
          }}</span>
        </p>
      </template>
    </div>
    <router-link
      tag="span"
      class="back-to"
      :to="`/${$route.params.lang}/all_works/albums_list/${$route.params.type}`"
      >{{ t.back }}</router-link
    >
  </div>
</template>

<script>
import Aplayer from "vue-aplayer";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      currentClass: 0,
      current: undefined,
      lyric: undefined,
      musicSource: {
        src: undefined,
      },
      options: {
        speed: 750,
        autoHeight: true,
        slidesPerView: 1,
        navigation: {
          nextEl: "#slide-nav__next",
          prevEl: "#slide-nav__prev",
        },
        pagination: {
          el: "#swiper-pagination",
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "lng",
      "t",
      "file",
      "album_item",
      "album_tracklist",
      "album_images",
    ]),
    item() {
      return this.album_item(this.$route.params.id);
    },
    tracklist() {
      return this.album_tracklist
        .filter((item) => {
          // check route type
          if (this.routerCheck()) {
            // filtering
            return (
              this.replaced("Performer:", item).match(/Sezen Aksu/g) !== null
            );
          } else {
            return item;
          }
        })
        .sort((a, b) => {
          return a.Position - b.Position;
        });
    },
  },
  watch: {
    tracklist(newValue, oldValue) {
      if (newValue[0]) {
        this.musicSource.src = this.file(newValue[0].FileLink);
        this.lyric = newValue[0];
        this.currentClass = newValue[0].ID;
      }
    },
  },
  methods: {
    routerCheck() {
      return (
        this.$route.params.type == "compilations" ||
        this.$route.params.type == "collaborations" ||
        this.$route.params.type == "soundtrack"
      );
    },
    close() {
      this.songNote.open = false;
      this.songNote.content = undefined;
    },
    replaced(type, arrayed) {
      const ex = arrayed.Contributors.split(",");
      const end = [];
      ex.find((s) => {
        if (s.match(type)) {
          end.push(s.replace(type, ""));
        }
      });
      return end.join(", ");
    },
    toggle(e) {
      this.current = undefined;
    },
    onMusicEnded() {
      // this.currentClass = undefined;
      this.current = undefined;
    },
    change(src, pts) {
      const demoP = this.$refs.demoPlayer;
      //if playing usic
      if (demoP.isPlaying) {
        if (src == demoP.currentMusic.src) {
          demoP.pause();
          this.currentClass = undefined;
          this.current = undefined;
        } else {
          this.currentClass = pts;
          this.current = pts;
          this.musicSource = {
            src: src,
          };
          demoP.thenPlay();
        }
      } else {
        this.musicSource = {
          src: src,
        };
        this.currentClass = pts;
        this.current = pts;
        demoP.thenPlay();
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
    Aplayer,
  },
  async created() {
    await this.$store.dispatch("album_tracklist", this.$route.params.id);
    await this.$store.dispatch("album_images", this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/colors";

.back-to {
  margin-bottom: 29px;
}

.no-content {
  text-align: center;
}

.album-info {
  padding: 20px 0;

  .album-main-info {
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 900px) {
      flex-direction: column;
    }

    .album-image-galery {
      width: 400px;
      padding: 0 20px;

      @media screen and (max-width: 480px) {
        width: 100%;
      }

      img {
        width: 100%;
      }

      .slide-controls-area {
        display: flex;
        padding: 5px 0;

        .slide-nav {
          color: $main;
          font-size: 25px;
          outline: none;
          cursor: pointer;

          &.swiper-button-disabled {
            color: #ccc;
          }
        }

        .swipe-paginate-area {
          flex: 1;
        }

        .swp-paginate {
          float: right;
        }
      }
    }

    .album-product-info {
      flex: 1;
      padding: 0 10px;
      color: #444;
      font-size: 15px;

      ul {
        display: inline-block;
        text-align: left;

        li {
          margin: 5px 0;

          strong {
            font-size: 15px;
            display: inline-block;
            min-width: 80px;
          }

          span {
            font-size: 15px;
          }
        }
      }

      .description {
        padding: 10px 0;

        & > div {
          max-height: 300px;
          overflow-y: auto;
        }
      }
    }
  }

  .access-list {
    padding: 10px 10px;
    margin-bottom: 20px;

    p {
      margin: 5px 0;
      font-size: 16px;
      color: #222;
    }

    ul {
      li {
        display: inline-block;
        position: relative;

        a {
          color: $main;
          font-size: 40px;
          margin-right: 15px;
        }

        span {
          display: none;
          text-align: center;
          position: absolute;
          font-size: 10px;
          bottom: -30px;
          width: 100%;
          left: 0;
          background: #8a32a7;
          padding: 5px 3px;
          border-radius: 2px;
          color: #fff;

          &:after {
            content: "";
            position: absolute;
            bottom: 100%;
            left: 38%;
            border: 5px solid transparent;
            border-bottom-color: #8a32a7;
          }
        }

        &:hover {
          a {
            color: #8a32a7;
          }

          span {
            display: block;
          }
        }
      }
    }
  }
}

.track-and-lyric-content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;

  @media screen and (max-width: 880px) {
    flex-direction: column;
  }
}

.track-list {
  flex: 1;
  margin-right: 2px;

  table.tracklist-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    th {
      border: 2px solid #fff;
      text-align: left;
      font-size: 12px;
      font-weight: bold;
      line-height: 18px;
      color: #222;
      padding: 3px;
      background: #d6d6d6;
      vertical-align: middle;

      &:last-child {
        width: 30px;
      }
    }

    tbody {
      tr {
        color: #008cba;

        &.active {
          color: rgb(73, 21, 91);
        }
      }

      td {
        font-size: 12px;
        cursor: default;
        padding: 3px;
        border: 2px solid #fff;

        span {
          &.track-title {
            cursor: pointer;
            font-size: 12px;
          }

          &.track-demo {
            cursor: pointer;
            text-align: center;
            font-size: 18px;
            vertical-align: middle;
            color: $main;
          }
        }

        &:last-child {
          text-align: center;
        }
      }

      tr {
        &:nth-child(odd) {
          background: #fff;
        }

        &:nth-child(even) {
          background: #d6d6d6;
        }
      }
    }
  }
}

.lyric-view {
  width: 50%;
  background: #dedede;
  border: 2px solid #fff;

  @media screen and (max-width: 880px) {
    width: 100%;
    margin-top: 10px;
  }

  .lyric-title {
    font-size: 15px;
    margin: 0;
    padding: 10px 10px 0;
    color: $main;
  }

  .lyric-info {
    color: #333;
    font-size: 12px;
    background: #c0c0c0;
    padding: 5px;
    display: flex;
    justify-content: space-between;

    ul {
      li {
        strong {
          width: 80px;
          font-size: 11px;
          display: inline-block;
          color: $main;
        }
      }
    }

    .song-note {
      color: $main;
      font-size: 25px;

      a {
        color: inherit;
        cursor: pointer;
        position: relative;

        small {
          display: none;
          font-family: inherit;
          font-size: 11px;
          font-family: "Open Sans", sans-serif;
          position: absolute;
          right: 100%;
          top: 0;
          padding: 3px;
          background: rgba(33, 33, 33, 0.5);
          color: #fff;
          margin-top: 4px;
          margin-right: 8px;
          border-radius: 3px;

          &:after {
            content: "";
            border: 5px solid transparent;
            border-left-color: rgba(33, 33, 33, 0.5);
            position: absolute;
            top: 4px;
            left: 100%;
          }
        }

        &:hover {
          color: $mainLight;

          small {
            display: block;
          }
        }
      }
    }
  }

  .lyric-content {
    padding: 10px;
    line-height: 18px;
    color: #444;
    font-size: 13px;
  }
}

.dg-stop-border {
  animation-name: color;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes color {
  0% {
    color: $main;
  }

  50% {
    color: dodgerblue;
  }

  100% {
    color: $main;
  }
}
</style>
